import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'documentVerificationAssetType',
    label: 'Asset',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'documentVerificationEmploymentType',
    label: 'Employment',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'documentVerificationIncomeType',
    label: 'Income',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'incomeDocumentationType',
    label: 'Income Documentation',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'debtServiceCoverageRatio',
    label: 'DSCR',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'prepaymentPenaltyTermMonths',
    label: 'Prepayment Penalty Term (Months)',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'prepaymentPenaltyStructure',
    label: 'Prepayment Penalty Structure',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const documentVerificationTypesForm = {
  name: FormNames.DOCUMENT_VERIFICATION_TYPES,
  label: 'Document Verification Types',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
